import { Fragment } from 'react';
import { ulid } from 'ulid';
import { Skeleton } from '@/components/ui/skeleton';

export const DataTableListLoadingSkeleton = () => (
  <div className="flex size-full flex-col gap-y-px bg-ui-container" data-testid="datatable-list-skeleton">
    <Skeleton
      className="h-12 w-full rounded-none bg-neutral-200 dark:bg-[#2D2D2D]"
      data-testid="datatable-list-header"
    />
    <div className="flex w-full flex-col gap-px">
      {Array.from(Array(10)).map((_, index) => (
        <div
          className="flex w-full flex-row gap-px"
          key={`skeleton-${index}`}
          data-testid={`datatable-list-row-${index}`}
        >
          <Skeleton
            className="h-9 w-1/4 rounded-none bg-neutral-200 dark:bg-ui-base"
            data-testid={`datatable-list-cell-${index}-0`}
          />
          <Skeleton
            className="h-9 w-1/6 rounded-none bg-neutral-200 dark:bg-ui-base"
            data-testid={`datatable-list-cell-${index}-1`}
          />
          <Skeleton
            className="h-9 w-1/3 rounded-none bg-neutral-200 dark:bg-ui-base"
            data-testid={`datatable-list-cell-${index}-2`}
          />
          <Skeleton
            className="h-9 w-1/4 rounded-none bg-neutral-200 dark:bg-ui-base"
            data-testid={`datatable-list-cell-${index}-3`}
          />
        </div>
      ))}
    </div>
  </div>
);

// Keep both styles of skeletons until we match the styles in the browse vs management section
export const BrowseDataTableListLoadingSkeleton = () => (
  <div className="flex size-full flex-col gap-y-px bg-ui-container" data-testid="browse-datatable-list-skeleton">
    <Skeleton className="h-12 w-full rounded-none" data-testid="browse-datatable-header" />
    <div
      className="grid w-full grid-cols-[20px_20px_40px_1fr_100px_100px] flex-col items-center gap-x-2 gap-y-1 px-2 py-1"
      data-testid="browse-datatable-grid"
    >
      {Array.from(Array(10)).map((_, rowIndex) => (
        <Fragment key={ulid()}>
          <Skeleton className="h-5 w-full bg-ui-panel!" data-testid={`browse-cell-${rowIndex}-0`} />
          <Skeleton className="h-5 w-full bg-ui-panel!" data-testid={`browse-cell-${rowIndex}-1`} />
          <Skeleton className="h-9 w-full bg-ui-panel!" data-testid={`browse-cell-${rowIndex}-2`} />
          <Skeleton className="h-5 w-full bg-ui-panel!" data-testid={`browse-cell-${rowIndex}-3`} />
          <Skeleton className="h-5 w-full bg-ui-panel!" data-testid={`browse-cell-${rowIndex}-4`} />
          <Skeleton className="h-5 w-full bg-ui-panel!" data-testid={`browse-cell-${rowIndex}-5`} />
        </Fragment>
      ))}
    </div>
  </div>
);
